
























import { Component, Vue, Prop } from 'vue-property-decorator';
import { CardContract } from '@/app/shared/components';
import { DataFilterModel } from '@/app/shared/models';
@Component({ components: { CardContract } })
export default class ListContractComponent extends Vue {
  @Prop(Array) readonly items!: DataFilterModel[];
}
